import { ref } from 'vue'
import { login as apiLogin, getInfo, logout as apiLogout } from '@/api/login'
import { setToken, removeToken, getToken } from '@/utils/auth'
import type { SysUserInfo } from '@/api/types'

export interface DisplayUser {
  name: string
  balance: string
  currency: string
  role: string
  email: string
  userId?: number
  raw?: SysUserInfo
}

export const currentUser = ref<DisplayUser | null>(null)

const roleLabels: Record<number, string> = {
  1: '超级管理员',
  2: '平台管理员',
  3: '业务员',
  4: '供应商',
  5: '代理用户',
  6: '消费用户',
}

function mapDisplayUser(user: SysUserInfo, roles?: string[]): DisplayUser {
  const balance = Number(user.balance ?? user.smsBalance ?? 0)
  const currency = user.currencyOfSettle || 'USD'
  const roleId = user.roleId ?? user.sysRole?.roleId
  const role = roleLabels[Number(roleId)] || roles?.[0] || '用户'
  return {
    name: user.userName || user.nickName || '用户',
    balance: balance.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
    currency,
    role,
    email: user.email || '',
    userId: user.userId,
    raw: user,
  }
}

export async function loginUser(username: string, password: string, code?: string, uuid?: string) {
  removeToken()
  const res = await apiLogin(username, password, code, uuid)
  setToken(res.data.token)
  await loadUserInfo()
}

export async function loadUserInfo() {
  if (!getToken()) {
    currentUser.value = null
    return null
  }
  const res = await getInfo()
  currentUser.value = mapDisplayUser(res.data.user, res.data.roles)
  return currentUser.value
}

export async function logoutUser() {
  try {
    await apiLogout()
  } catch {
    /* ignore */
  }
  removeToken()
  currentUser.value = null
}

export function isLoggedIn() {
  return !!getToken()
}
